export enum DefectStatus {
  All = 'all',
  ToRepair = 'toRepair',
}

export enum ReportState {
  All = 'all',
  Draft = 'draft',
  Submitted = 'submitted',
}
